
import api from "../../../../api/api"

const  serialize = (obj) =>{
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
      console.log(str)
    return str.join("&");
}

const getNotesData = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/report/notes?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const reportServices = {
    getNotesData
    
}
export default reportServices;